import API from './API.js'

export default class Deductions extends API {
  constructor() {
    super('deductions')
  }
}
